export enum LargeInstrumentWarehouseIssueType {
    INVOICE_ERROR = 'Invoice Error',
    INCORRECT_ORDERING_GUIDE = 'Incorrect Ordering Guide',
    INSTALL_KIT_ISSUE = 'Install Kit Issue',
    LIFECYCLE_ORDER_ENTRY_ERROR = 'Lifecycle Order Entry Error',
    MISSING_PRODUCT = 'Missing Product',
    RETURN_TO_STOCK = 'Return to Stock',
    MISSING_LATE_SHIPMENT = 'Missing/Late Shipment',
    QUALITY_REPLACEMENT_EXTERNAL_DAMAGE = 'Quality Replacement, External Damage',
    QUALITY_REPLACEMENT_INTERNAL_DAMAGE = 'Quality Replacement, Internal Damage (unit of sale)'
}
